import { useQuery } from "@apollo/client";
import { Spinner } from "evergreen-ui";
import React from "react";
import Message from "src/Message";
import { GET_DELIVERABLE_ORDERS } from "src/Queries/orders.shared";
import { getDateWithTime } from "src/utilities";
import styled from "styled-components";
import RecordRow from "../RecordRow";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 50vh;
`;

interface IProps {
  id: string;
}
const Shipments: React.SFC<IProps> = ({ id }) => {
  const { data, loading, error } = useQuery(GET_DELIVERABLE_ORDERS, {
    variables: {
      where: {
        buyer: { _eq: id },
      },
    },
  });

  const checkOrderType = (orderType) => {
    switch (orderType) {
      case "normal":
        return "Request Shipment";
      case "mms":
        return "MMS Order";
      case "retail":
        return "Retail Order";
      case "rb":
        return "RB Order";
      default:
        return "Shipment order";
    }
  };

  return (
    <Container>
      {loading && (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      )}
      {!loading && error && <Message label={"Error: " + error.message} />}
      {!loading &&
        data &&
        data.orders_with_delivery &&
        (data.orders_with_delivery.length > 0 ? (
          data.orders_with_delivery.map((order, index) => {
            return (
              <RecordRow
                key={index}
                item={`(ID: ${order.order_id}) ` + checkOrderType(order.type)}
                figure={order.quantity === 0 ? 0 : "- " + order.quantity}
                status={order.status}
                date={getDateWithTime(order.created_at)}
              />
            );
          })
        ) : (
          <Message label="No record found" />
        ))}
    </Container>
  );
};

export default Shipments;
